var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Section",
    [
      _c("SectionHeader", {
        attrs: { title: _vm.$t("apps.billing.message.summarybyservice") }
      }),
      _vm._v(" "),
      _c(
        "FormRow",
        [
          _c(
            "Col",
            { attrs: { className: "col-lg-12" } },
            [
              _c("BaseTable", {
                staticClass: "custom-table",
                attrs: { tableClass: "table-bordered", hidePagination: "" },
                scopedSlots: _vm._u([
                  {
                    key: "thead",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticStyle: { width: "125px" } }, [
                              _vm._v(_vm._s(_vm.$t("apps.billing.label.item")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticStyle: { width: "150px" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("apps.billing.label.detail"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.billing.label.usedwithcharge")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(_vm.$t("apps.billing.label.unitprice"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "text-right",
                                staticStyle: { width: "140px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("apps.billing.label.payamount"))
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tbody",
                    fn: function() {
                      return [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _vm.empty
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "5" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("message.notfounddata")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.apps, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.app.title) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "border-right": "1px solid #dee2e6"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.module.title) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.chargeUsedTotal) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getCurrencyWithNumber(
                                          _vm.numberel(item.unitPrice, "0,0.00")
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getCurrencyWithNumber(
                                          _vm.numberel(
                                            item.amountTotal,
                                            "0,0.00"
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ])
                            }),
                            _vm._v(" "),
                            _vm.showBranches
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.branch")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.branchcount"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.branches",
                                            {
                                              number: _vm.getRangeMinMax(
                                                _vm.data.branchUsedCountMin,
                                                _vm.data.branchUsedCountMax,
                                                _vm.data.branchUsedCount,
                                                { format: "0,0" }
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpricebranch",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.branchUnitPrice,
                                                  "0,0.00"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.branchAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showWarehouses
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.warehouse"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.warehousecount"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.warehouses",
                                            {
                                              number: _vm.getRangeMinMax(
                                                _vm.data.warehouseUsedCountMin,
                                                _vm.data.warehouseUsedCountMax,
                                                _vm.data.warehouseUsedCount,
                                                { format: "0,0" }
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpricewarehouse",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.warehouseUnitPrice,
                                                  "0,0.00"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.warehouseAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showUsers
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.user")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.usercount"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.users", {
                                            number: _vm.getRangeMinMax(
                                              _vm.data.userUsedCountMin,
                                              _vm.data.userUsedCountMax,
                                              _vm.data.userUsedCount,
                                              { format: "0,0" }
                                            )
                                          })
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpriceuser",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.userUnitPrice,
                                                  "0,0.00"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.userAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAppRecords
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      attrs: { rowspan: _vm.showFile ? 2 : 1 }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.billing.message.storage"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.application"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.records",
                                            {
                                              number: _vm.getRangeMinMax(
                                                _vm.data.appUsedRecordsMin,
                                                _vm.data.appUsedRecordsMax,
                                                _vm.data.appUsedRecords,
                                                { format: "0,0" }
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpriceapplication",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.appUnitPrice,
                                                  "0,0.00[000000]"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.appAmountTotal,
                                              "0,0.00[00000000]"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showFile
                              ? _c("tr", [
                                  _vm.showFile && !_vm.showAppRecords
                                    ? _c("td", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.billing.message.storage"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.file")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.files", {
                                            number: _vm.getRangeMinMax(
                                              _vm.data.fileUsedSizeMbMin,
                                              _vm.data.fileUsedSizeMbMax,
                                              _vm.data.fileUsedSizeMb,
                                              { format: "0,0.[00]" }
                                            )
                                          })
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpricefile",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.fileUnitPrice,
                                                  "0,0.00[000000]"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.fileAmountTotal,
                                              "0,0.00[00000000]"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showLineMessage
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: _vm.sum([
                                          1,
                                          _vm.showEmail ? 1 : 0,
                                          _vm.showQRCode ? 1 : 0
                                        ])
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("apps.billing.message.addon")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.linemessage"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.linemessages",
                                            {
                                              number: _vm.numberel(
                                                _vm.data.lineMessageCount,
                                                "0,0"
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpricelinemessage",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.lineUnitPrice,
                                                  "0,0.00[000000]"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.lineAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showEmail
                              ? _c("tr", [
                                  _vm.showEmail && !_vm.showLineMessage
                                    ? _c(
                                        "td",
                                        {
                                          attrs: {
                                            rowspan: _vm.sum([
                                              1,
                                              _vm.showQRCode ? 1 : 0
                                            ])
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.billing.message.addon"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.email")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.emails",
                                            {
                                              number: _vm.numberel(
                                                _vm.data.emailCount,
                                                "0,0"
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpriceemail",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.emailUnitPrice,
                                                  "0,0.00[000000]"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.emailAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showQRCode
                              ? _c("tr", [
                                  _vm.showQRCode &&
                                  !_vm.showLineMessage &&
                                  !_vm.showEmail
                                    ? _c("td", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.billing.message.addon"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.qrcode")
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.qrcodes",
                                            {
                                              number: _vm.numberel(
                                                _vm.data.qrcodeCount,
                                                "0,0"
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.billing.message.unitpriceqrcode",
                                            {
                                              number: _vm.getCurrencyWithNumber(
                                                _vm.numberel(
                                                  _vm.data.qrcodeUnitPrice,
                                                  "0,0.00[000000]"
                                                )
                                              )
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getCurrencyWithNumber(
                                            _vm.numberel(
                                              _vm.data.qrcodeAmountTotal,
                                              "0,0.00"
                                            )
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("Col", { attrs: { className: "col-lg-12" } }, [
            _c("div", { staticClass: "summary-container" }, [
              _c("div", { staticClass: "text" }, [
                _c("strong", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.billing.message.total")) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.getCurrencyWithNumber(
                        _vm.numberel(_vm.data.total, "0,0.00")
                      )
                    ) +
                    "\n      "
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b466f778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b466f778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/BillingInvoiceSummary.vue
// module id = null
// module chunks = 